webpackJsonp([3],{

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = horizontalScrollMenu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaults__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_defaults__);


function horizontalScrollMenu(targetElement, options) {
  options = options || {};
  __WEBPACK_IMPORTED_MODULE_1_lodash_defaults___default()(options, {
    //selectedClassName: 'selected'
    fixed: true,
    scrollMenu: '.js-scroll-menu',
    scrollItem: '.scroll-menu__item',
    scrollItemActive: 'scroll-menu__item--active',
    scrollMenuFixed: 'scroll-menu--fixed',
    speed: 200
  });

  //Apply active class for styling (mobile)
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.scrollItem).on("click", function () {
    var thisItem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    thisItem.siblings().removeClass(options.scrollItemActive).end().addClass(options.scrollItemActive);
  });

  //Fix Designer Menu header on scroll
  var fixedMenu = function fixedMenu() {
    if (options.fixed) {
      var element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.scrollMenu);
      var elementHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).outerHeight(true);
      var scrollPosY = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop();
      var elementOffset = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).offset().top + elementHeight;
      var distance = elementOffset - scrollPosY;
      if (scrollPosY > distance) {
        element.addClass(options.scrollMenuFixed);
      } else {
        element.removeClass(options.scrollMenuFixed);
      }
    }
  };

  //Adjust anchor scroll based on fixed header
  var adjustAnchor = function adjustAnchor() {
    var $anchor = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(':target');
    var element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.scrollMenu);
    var elementHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).outerHeight(true);
    if ($anchor.length > 0) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').stop().animate({
        scrollTop: $anchor.offset().top - elementHeight
      }, options.speed);
      console.log('hit');
    }
  };
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('scroll resize', fixedMenu);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('hashchange load', adjustAnchor);
} //End horizontalScrollMenu

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_body_scroll_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vendor_typeahead__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vendor_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vendor_typeahead__);
/**
 * Designer Search Plugin
 * Creates a searchable dialog with typeahead functionality for designer brands
 * @module elements/fields/designerSearch
 */






// Plugin constants
var PLUGIN_NAME = 'searchDesigner';
var DEFAULTS = {
  searchDialog: '.js-search-dialog',
  typeaheadInput: '#search-designer-input',
  closeButton: '.js-search-dialog-close',
  clearButton: '.js-search-dialog-clear',
  submitButton: '.js-search-dialog-submit'
};

/**
 * Initializes the search typeahead functionality
 * @param {jQuery} $el - The element that triggers the search dialog
 * @param {Object} opts - Configuration options
 */
var initSearch = function initSearch($el, opts) {
  var typeaheadInput = opts.typeaheadInput;

  // Designer brands data with metadata
  var designerBrands = window.rcProps.searchDesignerBrands;

  // JSON strings for recent and recommended searches
  var recentSearchJson = window.rcProps.searchDesignerRecentSearches;
  var recommendedSearchJson = window.rcProps.searchDesignerRecommendations;

  /**
   * Finds the closest matching brand suggestion for a given query using Levenshtein distance
   * @param {string} query - The search query
   * @returns {string|null} - The closest match or null if none found
   */
  function findClosestMatch(query) {
    if (!query || query.length < 2) return null;
    var bestMatch = null;
    var bestDistance = Infinity;
    designerBrands.forEach(function (brand) {
      var distance = levenshteinDistance(query.toLowerCase(), brand.suggestion.toLowerCase());
      if (distance < bestDistance && distance < 4) {
        bestDistance = distance;
        bestMatch = brand;
      }
    });
    return bestMatch;
  }

  /**
   * Calculates Levenshtein distance between two strings for fuzzy matching
   * @param {string} a - First string
   * @param {string} b - Second string
   * @returns {number} - The edit distance between strings
   */
  function levenshteinDistance(a, b) {
    if (a.length === 0) return b.length;
    if (b.length === 0) return a.length;
    var matrix = [];

    // Initialize matrix
    for (var i = 0; i <= b.length; i++) {
      matrix[i] = [i];
    }
    for (var j = 0; j <= a.length; j++) {
      matrix[0][j] = j;
    }

    // Fill matrix
    for (var _i = 1; _i <= b.length; _i++) {
      for (var _j = 1; _j <= a.length; _j++) {
        var cost = a[_j - 1] === b[_i - 1] ? 0 : 1;
        matrix[_i][_j] = Math.min(matrix[_i - 1][_j] + 1,
        // deletion
        matrix[_i][_j - 1] + 1,
        // insertion
        matrix[_i - 1][_j - 1] + cost // substitution
        );
      }
    }
    return matrix[b.length][a.length];
  }

  // Mustache templates for rendering suggestions and empty results
  var suggestionTemplate = "<li class=\"border-b--xs border-t u-border--xs border-color-ea ui-list__item u-list-style--none tt-suggestion tt-selectable\">\n                                    <a href=\"{{href}}\" class=\"link link--noline\">\n                                        <p class=\"u-padding-l--lg u-margin-tb--lg u-padding-r--lg u-text--xl\">\n                                            {{suggestion}}\n                                            {{#isBrand}}\n                                            &nbsp;<i class=\"u-text--sm u-color--grey\">{{#isWomens}}<rev:t>in womens</rev:t>{{/isWomens}}{{^isWomens}}<rev:t>in mens</rev:t>{{/isWomens}}<i>\n                                            {{/isBrand}}\n                                        </p>\n                                    </a>\n                                </li>";
  var emptyTemplate = "<div class=\"empty-message\">\n                            <p>No results found for \"{{query}}\"</p>\n                            {{#suggestion}}\n                            <p>Did you mean <a class=\"suggestion-link\" data-suggestion=\"{{suggestion}}\" href=\"{{suggestionUrl}}\">{{suggestion}}</a>?</p>\n                            {{/suggestion}}\n                        </div>";
  var headRecentTemplate = "<p id=\"js-search-hed-target\" class=\"product-recs__hed h4\">Recent Searches</p>";
  var headRecommendedTemplate = "<p id=\"js-search-hed-target\" class=\"product-recs__hed h4\">Designers You'll Love</p>";
  var recommendedSuggestionTemplate = "<li class=\"border-b--xs border-t u-border--xs border-color-ea ui-list__item u-list-style--none tt-suggestion tt-selectable\">\n                                                <a href=\"{{href}}\" class=\"link link--noline u-padding-l--xxl u-block\">\n                                                    <p class=\"u-padding-l--lg u-margin-tb--lg u-padding-r--lg u-text--lg\">\n                                                    <span class=\"u-margin-l--xs\">{{searchText}}</span>\n                                                    </p>\n                                                </a>\n                                            </li>";

  /*
  * Custom search function for substring matching with priority for prefix matches
  * @param {Array} strs - Array of brand objects to search
  * @returns {Function} - Function that finds matches for a query
  */
  var substringMatcher = function substringMatcher(strs) {
    return function findMatches(query, cb) {
      // Array to hold matches
      var matches = [];

      // Return empty array if query is empty
      if (query === '') {
        return cb(matches);
      }

      // Regex for matching
      var substrRegex = new RegExp(query, 'i');
      // Regex for matching at the beginning of string
      var prefixRegex = new RegExp('^' + query, 'i');

      // Iterate through brands
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(strs, function (i, brand) {
        // Check if name contains the substring
        if (substrRegex.test(brand.suggestion)) {
          // Add highlighting data
          var highlighted = brand.suggestion.replace(new RegExp('(' + query + ')', 'ig'), '<span class="match">$1</span>');

          // Clone brand object and add highlighting
          var match = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, brand, {
            highlightedName: highlighted,
            // Set isPrefixMatch flag if the brand name starts with the query
            isPrefixMatch: prefixRegex.test(brand.suggestion)
          });
          matches.push(match);
        }
      });

      // Sort matches to prioritize prefix matches
      matches.sort(function (a, b) {
        // If one is a prefix match and the other isn't, the prefix match comes first
        if (a.isPrefixMatch && !b.isPrefixMatch) return -1;
        if (!a.isPrefixMatch && b.isPrefixMatch) return 1;

        // If both are prefix matches or both are not, sort alphabetically
        return a.suggestion.localeCompare(b.suggestion);
      });

      // Update stats
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-stats').text(matches.length + ' brands found').show();
      if (!query) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-stats').hide();
      }
      cb(matches);
    };
  };

  // Initialize Typeahead with multiple datasets
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(typeaheadInput).typeahead({
    hint: false,
    highlight: true,
    autoselect: false,
    minLength: 0,
    classNames: {
      menu: 'field__input-search-results',
      highlight: 'site-search__highlight'
    }
  }, {
    // Dataset 1: Text suggestions based on user input
    name: 'textSuggestions',
    source: substringMatcher(designerBrands),
    display: 'suggestion',
    limit: 10,
    templates: {
      suggestion: function suggestion(data) {
        var query = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-designer-input').val();
        var encodedValue = encodeURIComponent(query);
        var url = data.suggestionUrl.replace(/&q=&/, "&q=".concat(encodedValue, "&"));
        return Mustache.render(suggestionTemplate, {
          href: url,
          suggestion: data.suggestion,
          isBrand: data.termType === "Brand",
          isWomens: /^w.*/i.test(data.gender)
        });
      },
      empty: function empty(context) {
        var query = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-designer-input').val();
        var bestMatch = findClosestMatch(query);
        return Mustache.render(emptyTemplate, {
          query: query,
          suggestion: bestMatch ? bestMatch.suggestion : null,
          suggestionUrl: bestMatch ? bestMatch.suggestionUrl : '#'
        });
      }
    }
  }, {
    // Dataset 2: Recent searches (shown when search field is empty)
    name: 'recent',
    display: function display(obj) {
      return obj.searchText;
    },
    source: function source(query, callback) {
      // hide dataset when user starts typing
      var recentOnInput = query === '' ? recentSearchJson : JSON.parse('[]');
      callback(recentOnInput);
    },
    templates: {
      header: function header() {
        return headRecentTemplate;
      },
      suggestion: function suggestion(data) {
        return Mustache.render(rcProps.search.recentSearchTemplate, data);
      }
    },
    limit: rcProps.recentSearchLimit
  }, {
    // Dataset 3: Recommended searches (shown when search field is empty)
    name: 'recommended',
    display: function display(obj) {
      return obj.searchText;
    },
    source: function source(query, callback) {
      // hide dataset when user starts typing
      var recommendedOnInput = query === '' ? recommendedSearchJson : '[]';
      callback(JSON.parse(recommendedOnInput));
    },
    templates: {
      header: function header() {
        return headRecommendedTemplate;
      },
      suggestion: function suggestion(data) {
        return Mustache.render(recommendedSuggestionTemplate, data);
      }
    },
    limit: rcProps.recentSearchLimit
  });

  /**
   * Shows search results and hides other suggestion types
   * @param {jQuery} suggestionList - jQuery object for suggestion list
   */
  var hideOriginalSuggestions = function hideOriginalSuggestions(suggestionList) {
    suggestionList.show();
  };

  /**
   * Shows original suggestion types and hides search results
   * @param {jQuery} suggestionList - jQuery object for suggestion list
   */
  var showOriginalSuggestions = function showOriginalSuggestions(suggestionList) {
    suggestionList.hide();
  };

  // Handle input changes to show/hide appropriate suggestion types
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(typeaheadInput).on('input', function (e) {
    var suggestionList = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.field__input-search-results .tt-dataset-textSuggestions');
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).val().length > 0) {
      hideOriginalSuggestions(suggestionList);
    } else {
      showOriginalSuggestions(suggestionList);
    }
  });

  // Handle selection from typeahead
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(typeaheadInput).on('typeahead:select', function (ev, suggestion) {
    window.location.href = !!suggestion.suggestionUrl ? suggestion.suggestionUrl : suggestion.href;
  });

  // Reset stats when input is cleared
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.typeahead').on('keyup', function () {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val() === '') {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search-stats').hide();
    }
  });

  // Hide suggestion list on initial render
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(typeaheadInput).on('typeahead:render', function (event, suggestions) {
    var suggestionList = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.field__input-search-results .tt-dataset-textSuggestions');
    suggestionList.hide();
  });
};

/**
 * Merges default and provided options
 * @param {jQuery} $el - Button/element that opens search dialog
 * @param {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Final options object
 */
var mergeOptions = function mergeOptions($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULTS, options);
};

/**
 * Closes the search dialog
 * @param {jQuery} $el - Trigger element
 * @param {Object} opts - Options object
 */
var closeSearchDialog = function closeSearchDialog($el, opts) {
  var searchDialog = opts.searchDialog,
    typeaheadInput = opts.typeaheadInput;
  var searchFormDialogActive = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(searchDialog).attr('aria-modal') === 'true';
  if (searchFormDialogActive) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(searchDialog).attr('aria-modal', false);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.form-search-overlay').remove();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(searchDialog).hide();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__["enableBodyScroll"])(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results')[0]);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el).trigger('focus');
  }
};

/**
 * Opens the search dialog
 * @param {jQuery} $el - Trigger element
 * @param {Object} opts - Options object
 */
var showSearchDialog = function showSearchDialog($el, opts) {
  var searchDialog = opts.searchDialog,
    typeaheadInput = opts.typeaheadInput;
  var searchFormDialogNotActive = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(searchDialog).attr('aria-modal') === 'false';
  if (searchFormDialogNotActive) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(searchDialog).appendTo('body');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(searchDialog).show();

    // Initialize typeahead if not already done
    if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(typeaheadInput).hasClass('tt-input')) {
      initSearch($el, opts);
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(typeaheadInput).trigger('focus');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(searchDialog).attr('aria-modal', true);

    // Add overlay with click handler to close dialog
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='form-search-overlay'></div>").appendTo('body').on('click', function () {
      closeSearchDialog($el, opts);
    });

    // Prevent body scrolling while dialog is open
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_body_scroll_lock__["disableBodyScroll"])(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results')[0]);

    // Trap keyboard focus within dialog
    __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].trapFocus(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(searchDialog));
  }
};

/**
 * Shows the clear and submit buttons
 * @param {string} clearButton - Clear button selector
 * @param {string} submitButton - Submit button selector
 */
var showControls = function showControls(clearButton, submitButton) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(clearButton).show();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(submitButton).show();
};

/**
 * Hides the clear and submit buttons
 * @param {string} clearButton - Clear button selector
 * @param {string} submitButton - Submit button selector
 */
var hideControls = function hideControls(clearButton, submitButton) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(clearButton).hide();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(submitButton).hide();
};

/**
 * Toggles visibility of control buttons based on input state
 * @param {jQuery} $el - Trigger element
 * @param {Object} opts - Options object
 */
var toggleControls = function toggleControls($el, opts) {
  var clearButton = opts.clearButton,
    submitButton = opts.submitButton,
    typeaheadInput = opts.typeaheadInput;
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(typeaheadInput).val().length > 0) {
    showControls(clearButton, submitButton);
  } else {
    hideControls(clearButton, submitButton);
  }
};

/**
 * Clears the search input and resets the UI
 * @param {jQuery} $el - Trigger element
 * @param {Object} opts - Options object
 */
var clearSearch = function clearSearch($el, opts) {
  var typeaheadInput = opts.typeaheadInput,
    clearButton = opts.clearButton,
    submitButton = opts.submitButton;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(typeaheadInput).typeahead('val', '');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(typeaheadInput).trigger('focus');
  hideControls(clearButton, submitButton);
};

/**
 * Sets up event listeners for the search dialog
 * @param {jQuery} $el - Trigger element
 * @param {Object} opts - Options object
 */
var setEventListeners = function setEventListeners($el, opts) {
  var closeButton = opts.closeButton,
    typeaheadInput = opts.typeaheadInput,
    clearButton = opts.clearButton;

  // Click on element opens search dialog
  $el.on('click', function () {
    return showSearchDialog($el, opts);
  });

  // Click on close button closes dialog
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(closeButton).on('click', function () {
    return closeSearchDialog($el, opts);
  });

  // Input events toggle visibility of controls
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(typeaheadInput).on('input', function () {
    return toggleControls($el, opts);
  });

  // Click on clear button resets search
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(clearButton).on('click', function () {
    return clearSearch($el, opts);
  });
};

/**
 * Main plugin function - initializes the designer search functionality
 * @param {HTMLElement} el - Element that triggers the search dialog
 * @param {Object} options - Configuration options
 */
function searchDesigner(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = mergeOptions($el, options);
  setEventListeners($el, opts);
}

// Register as a jQuery plugin
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, searchDesigner);

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__horizontal_scroll_menu__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_heart_product__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search_designer__ = __webpack_require__(178);



// var searchDesigner = require('./search-designer');

function bindHeartItems() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_modules_heart_product__["a" /* default */])('#pageItems', '.fav-item');
}
function initHorizontalScrollmenu() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__horizontal_scroll_menu__["a" /* default */])();
}
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-scroll-menu').length) {
    initHorizontalScrollmenu();
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-favorite-designer').on('click', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass('favorite-button--heart-active');
  });
  bindHeartItems();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-trigger-search-designer').searchDesigner();
});

/***/ })

},[216]);


// WEBPACK FOOTER //
// dist/designers.js